import React, { useContext } from "react";

import { OrderListingContext } from "../listing/context/OrderListingContext";
import { OrderListingItem } from "../listing/OrderListingItem";
import { CompleteRejectedOrderModal } from "./CompleteRejectedOrderModal";

type CompleteRejectedOrderListingDialogProps = {
    item: OrderListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const CompleteRejectedOrderListingDialog: React.VFC<CompleteRejectedOrderListingDialogProps> = ({
    item,
    isOpen,
    onClose
}: CompleteRejectedOrderListingDialogProps) => {
    const { completeRejected } = useContext(OrderListingContext);

    const handleCompletion = async (completionDetails?: string) => {
        completeRejected(item.id, completionDetails);

        onClose();
    };

    return (
        <CompleteRejectedOrderModal isOpen={isOpen} onCancel={onClose} onSubmit={handleCompletion} orderId={item.id} />
    );
};
